
class Adapter {
  convertMessage (message) {
    const converted = {
      author: this._resolveAuthor(message),
      direction: message.direction,
      type: message.content.type,
      id: message.id,
      isEdited: false,
      data: this._convertPayload(message.content)
    }
    if (message.content.quick_replies) {
      converted.suggestions = message.content.quick_replies
    }

    if (message.metadata) converted.metadata = message.metadata

    return converted
  }

  _convertPayload (content) {
    if (content.type === 'text') return { text: content.payload }
    if (content.type === 'structure') return content.payload
    if (content.type === 'file') return { url: content.payload.url }
    return content.payload
  }

  _resolveAuthor (message) {
    if (message.direction === 'received') {
      return message.metadata?.amio_bot || message.metadata?.ai_generated ? 'bot' : 'operator'
    }

    return 'client'
  }
}

export default new Adapter()
